import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import { FillTheFieldErrorMessage, FormInput } from "@/shared/Components";

type Props = {
  index: number;
  onBlur?: () => void;
  onChange?: () => void;
};

export const ProfessionalActivitiesField = ({ index, onBlur, onChange }: Props) => {
  const { t } = useTranslation();

  const handleBlur = useCallback(() => {
    onBlur?.();
  }, [onBlur]);

  return (
    <FieldLayout>
      <FillTheFieldErrorMessage name={`professionalActivities.${index}`} />
      <FormInput
        name={`professionalActivities.${index}.activity`}
        placeholder={t("contactsPage.activities.activity")}
        onBlur={handleBlur}
      />
      <FormInput
        name={`professionalActivities.${index}.industry.name`}
        placeholder={t("contactsPage.activities.industry")}
        onBlur={handleBlur}
        customOnChange={onChange}
      />
      <FormInput
        name={`professionalActivities.${index}.role`}
        placeholder={t("contactsPage.activities.role")}
        onBlur={handleBlur}
      />
    </FieldLayout>
  );
};
